import { Button } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import MESSAGES from 'core/data-model/constants/messages'
import { getCurrentMaturityIDCard, canEnableBtnProceedToSelectPolicyOwner } from 'quick-quote/product-sio/selectors'
import { isLoading } from 'quick-quote/ui/selectors'
import { maturityValidate } from 'quick-quote/product-sio/actions'

export const _MaturityValidateButton = (props) => {
  const RealButton = (
    <Button
      className="e-submission"
      color={!props.enableBtnMaturityValidate || props.isServiceProcessing ? 'disabled' : 'primary'}
      onClick={() => props.maturityValidate(props.currentMaturityIDCard)}
      disabled={!props.enableBtnMaturityValidate || props.isServiceProcessing ? true : false}
    >
      {MESSAGES.SUBMIT}
    </Button>
  )
  return RealButton
}

const mapStateToProps = (state) => ({
  currentMaturityIDCard: getCurrentMaturityIDCard(state),
  enableBtnMaturityValidate: canEnableBtnProceedToSelectPolicyOwner(state),
  isServiceProcessing: isLoading(state),
})

const mapDispatchToProps = (dispatch) => ({
  maturityValidate: bindActionCreators(maturityValidate, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(_MaturityValidateButton)
